import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { IGameTypeSpectator } from "../../IGameTypeSpectator";
import { SitngoTypeStandard } from "../SitngoTypeStandard";

export class SitngoTypeStandardSpectator extends SitngoTypeStandard implements IGameTypeSpectator {
    public get isGameTypeSpectator(): boolean {
        return true;
    }
}
classImplementsInterfaces(SitngoTypeStandardSpectator, "IGameTypeSpectator");
